/*eslint-disable*/
import moment from 'moment';
import { createColumnHelper } from '@tanstack/react-table';
import { ActionData, ActionsTypes, Option, UserDetails } from '../constants/telosair-interfaces';
import { ROLE_BY_ID } from '../constants/global-constants';
import DropdownCustom from '../controls/DropdownCustom';

const options: Option<ActionsTypes>[] = [
  { name: 'Edit user', id: 'edit' },
  { name: 'Delete user', id: 'delete' },
  { name: 'Resend Invite', id: 'resend-invite' },
  { name: 'Copy invite link', id: 'copy-invite' }
];

const columnHelper = createColumnHelper<
  UserDetails & { action: (action: ActionData<UserDetails>) => void }
>();

// Only Admins manage users, so everyone else gets the table without the Action column.
export const getUserTableColumns = (isAdmin: boolean) => [
  columnHelper.accessor('id', {
    cell: (info) => info.getValue(),
    header: () => <span>Serial No</span>
  }),
  columnHelper.accessor('firstName', {
    cell: ({ row }) => (
      <div>
        <div> {row.original.firstName}</div>
        <div className="text-gray-500 text-xs ">{row.original.userName}</div>
      </div>
    ),
    header: () => <span>User</span>
  }),
  columnHelper.accessor((row) => row.role, {
    id: 'role',
    cell: (info) => <i>{ROLE_BY_ID[info.getValue()] ?? '-'}</i>,
    header: () => <span>Role</span>
  }),
  columnHelper.accessor('lastActive', {
    header: () => 'Last Login',
    cell: (info) => {
      const renderValue = info.renderValue();
      if (renderValue != null) {
        // Shown in the viewer's own time zone.
        return (
          <span title={moment(renderValue).format('LLLL')}>
            {moment(renderValue).format('YYYY/MM/DD h:mm A')}
          </span>
        );
      } else {
        return 'Never';
      }
    }
  }),
  ...(isAdmin ? [actionColumn] : [])
];

const actionColumn = columnHelper.accessor('action', {
    header: () => <span>Action</span>,
    cell: (row: any) => {
      return (
        <DropdownCustom<ActionsTypes>
          onClick={(type) =>
            row?.row?.original?.action({
              type,
              data: row?.row?.original
            })
          }
          controlPlaceholder="Action"
          buttons={options}
        />
      );
    }
  });
/*eslint-disable*/
